var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCancel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none;stroke:#007dc3;stroke-linecap:round;stroke-width:1.6px}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_367_4",
    "data-name": "Component 367 \\u2013 4",
    transform: "translate(1.131 1.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    d: "M0 12.98V0",
    className: "cls-1",
    "data-name": "Path 973",
    transform: "rotate(45 4.589 11.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    d: "M0 0v12.979",
    className: "cls-1",
    "data-name": "Path 974",
    transform: "rotate(135 2.688 6.49)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCancel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cancel.948584b8.svg";
export { ForwardRef as ReactComponent };